type Options = Partial<MegaMenuOptions>;

export interface MegaMenuElement extends HTMLElement {
  megamenu?: MegaMenu;
}

export interface MegaMenuOptions {
  itemSelector: string;
  activeClass: string;
}

export class MegaMenu {
  static defaults = {
    activeClass: 'is-open',
    itemSelector: '.megamenu__item',
  };
  options: MegaMenuOptions;
  element: MegaMenuElement;
  touch = false;
  items: Element[];
  touchStartHandler: EventListener;
  clickHandler: EventListener;

  constructor(element: MegaMenuElement, options?: Options) {
    if (!element || element.megamenu) {
      return;
    }

    element.megamenu = this;
    this.element = element;
    this.options = {
      ...MegaMenu.defaults,
      ...options,
    };

    const items = this.element.querySelectorAll(this.options.itemSelector);

    if (!items) {
      return;
    }

    this.items = Array.from(items);

    this.bind();
  }

  bind() {
    this.touchStartHandler = this.handleTouchStart.bind(this);
    this.clickHandler = this.handleClick.bind(this);

    document.documentElement.addEventListener(
      'touchstart',
      this.touchStartHandler,
    );
    this.element.addEventListener('click', this.clickHandler);
  }

  handleClick(event: Event) {
    const target = event.target as HTMLElement;
    const match = target.closest(this.options.itemSelector);

    if (!match) {
      return;
    }

    if (this.touch) {
      event.preventDefault();
    }
  }

  handleTouchStart(event: Event) {
    const target = event.target as Element;
    const match = target.closest(this.options.itemSelector) as Element;

    this.isActive(match) ? (this.touch = false) : (this.touch = true);
    this.clearItems();

    if (match) {
      match.classList.add(this.options.activeClass);
    }
  }

  clearItems() {
    this.items.map(item => item.classList.remove(this.options.activeClass));
  }

  isActive(element: Element) {
    return element && element.classList.contains(this.options.activeClass);
  }

  destroy() {
    document.documentElement.removeEventListener(
      'touchstart',
      this.touchStartHandler,
    );

    this.element.removeEventListener('click', this.clickHandler);
    this.element.megamenu = undefined;

    this.clearItems();
  }
}
